export default __webpack_public_path__ + "static/media/answer-picture-red.6f7e028b.png";